import "./style.css";

export default class Header {
  static selector = ".header";

  constructor(block) {
    this.block = block;

    const menuBtn = this.block.querySelector("#menu-btn");
    menuBtn.addEventListener("click", this.onMenuBtnClick);

    this.loginButton = this.block.querySelector(".header__nav__login-button");
    this.mobileLoginButton = this.block.querySelector(
      ".header__menu__login-button"
    );

    this.prevScrollY = window.pageYOffset;
    this.overlay = document.querySelector("#overlay");
  }

  handleLoginButtonClick = () => {
    window.App.modals.login.open();
  };

  onScroll = () => {
    const currScrollY = window.pageYOffset;
    const navHeight = this.block.offsetHeight;

    if (Math.abs(this.prevScrollY - currScrollY) <= navHeight / 2) return;

    const collapse = currScrollY > this.prevScrollY && currScrollY > navHeight;
    this.block.classList.toggle("collapsed", collapse);

    this.prevScrollY = currScrollY;
  };

  onMenuBtnClick = () => {
    const shown = this.block.classList.toggle("show-menu");
    document.body.classList.toggle("no-scroll", shown);
    this.overlay.classList.toggle("no-display", !shown);
  };

  onReady = () => {
    if (this.loginButton) {
      this.loginButton.addEventListener("click", this.handleLoginButtonClick);
    }

    if (this.mobileLoginButton) {
      this.mobileLoginButton.addEventListener(
        "click",
        this.handleLoginButtonClick
      );
    }
  };

  onDestroy = () => {
    if (this.loginButton) {
      this.loginButton.removeEventListener(
        "click",
        this.handleLoginButtonClick
      );
    }

    if (this.mobileLoginButton) {
      this.mobileLoginButton.removeEventListener(
        "click",
        this.handleLoginButtonClick
      );
    }
  };
}
